export function photoFileUrl(clientId: string, photoId: string, variant: 'thumb' | 'full'): string {
	return `${import.meta.env.VITE_BACK_URL}/clients/${clientId}/photos/${photoId}/file?variant=${variant}`;
}

export function photoDownloadFileName(mediaId: string): string {
	const safe = mediaId.replace(/[^a-zA-Z0-9._-]/g, '_');
	return `${safe || 'photo'}.jpg`;
}
